import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { URL } from '../../../redux/common/url';
import { AsyncPaginate } from 'react-select-async-paginate';
import moment from 'moment';
import axios from 'axios';
import { DatePicker } from 'antd';
import { usePDF } from 'react-to-pdf';

import './table.css';

interface Option {
    value: string | number;
    label: string;
    id?: string | number;
    name?: string;
    user_name?: string;
}

interface PaginatedResponse {
    results: Option[];
    has_more: boolean;
}

interface InvoiceData {
    date: string;
    vehicle: {
        id: number;
        vehicle_name: string;
        registration_number?: string;
    };
    vehicle_id: number;
    distance_0_5_km: number;
    distance_5_10_km: number;
    distance_10_15_km: number;
    distance_15_20_km: number;
    distance_20_plus_km: number;
    total_trips: number;
}

interface InvoiceSummary {
    circle_id: number;
    total_0_5_km_trips: number;
    rate_0_5: number;
    amount_0_5: number;
    total_5_10_km_trips: number;
    rate_5_10: number;
    amount_5_10: number;
    total_10_15_km_trips: number;
    rate_10_15: number;
    amount_10_15: number;
    total_15_20_km_trips: number;
    rate_15_20: number;
    amount_15_20: number;
    total_20_plus_km_trips: number;
    rate_20_plus: number;
    amount_20_plus: number;
    grand_total: number;
}

const Vef_Invoice = () => {
    const [userProfile, setUserProfile] = useState<any>(null);
    const [userPrefix, setUserPrefix] = useState<string>('admins');

    const [criId, setCriId] = useState<string>('');
    const [circles, setCircles] = useState<Option[]>([]);

    const [seleceteMangerXen, setSeleceteMangerXen] = useState<Option | null>(null);
    const [seleceteMangerAen, setSeleceteMangerAen] = useState<Option | null>(null);
    const [seleceteMangerJen, setSeleceteMangerJen] = useState<Option | null>(null);
    const [seleceteMangerVendor, setSeleceteMangerVendor] = useState<Option | null>(null);

    const [startDate, setStartDate] = useState<moment.Moment | null>(null);
    const [endDate, setEndDate] = useState<moment.Moment | null>(null);
    const [invoiceData, setInvoiceData] = useState<InvoiceData[]>([]);
    const [invoiceSummary, setInvoiceSummary] = useState<InvoiceSummary | null>(null);
    const [tpPercentage, setTpPercentage] = useState<number>(0);

    const [billNo, setBillNo] = useState<string>(`PHED-N-${moment().format('YYYYMMDD')}-`);
    const [refNo, setRefNo] = useState<string>('');
    const [gstinNo, setGstinNo] = useState<string>('');
    const [orderNo, setOrderNo] = useState<string>('');

    const { toPDF, targetRef } = usePDF({ filename: 'phed_invoice.pdf' });

    // Auto-fill based on login role + detect prefix
    useEffect(() => {
        const tokenStr = localStorage.getItem('kt-auth-react-v');
        if (!tokenStr) return;

        try {
            const tokenData = JSON.parse(tokenStr);
            const user = tokenData?.data || {};
            setUserProfile(user);

            const prefix = (user?.prefix || '').toLowerCase().trim();
            setUserPrefix(prefix || 'admins');

            if (user?.circle_id) setCriId(user.circle_id.toString());

            if (prefix === 'jens' || user.role_id === 7) {
                setSeleceteMangerJen({
                    value: user.id,
                    id: user.id,
                    label: user.name || user.user_name || '',
                    name: user.name || user.user_name
                });
            } else if (prefix === 'aens' || user.role_id === 6) {
                setSeleceteMangerAen({
                    value: user.id,
                    id: user.id,
                    label: user.name || user.user_name || '',
                    name: user.name || user.user_name
                });
            } else if (prefix === 'xens' || user.role_id === 5) {
                setSeleceteMangerXen({
                    value: user.id,
                    id: user.id,
                    label: user.name || user.user_name || '',
                    name: user.name || user.user_name
                });
            }
        } catch (err) {
            console.error("Failed to parse token", err);
        }
    }, []);

    // Helper to get API URL with dynamic prefix
    const getPrefixedUrl = (endpoint: string): string => {
        return `${URL.API_BASE_URL}/api/${userPrefix}/${endpoint}`;
    };

    const fetchCircles = async () => {
        try {
            const res = await axios.get(`${URL.API_BASE_URL}${URL.getAllCircles}`);
            setCircles(res?.data?.data || []);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        fetchCircles();
    }, []);

    // Load Options
    const loadOptionsXen = async (search: string, _: any, { page }: any): Promise<any> => {
        if (!criId) return { options: [], hasMore: false, additional: { page: 1 } };

        const token: any = await localStorage.getItem('kt-auth-react-v');
        const res = await fetch(
            `${getPrefixedUrl('get_all_xen')}?search=${search}&page=${page}&circle_id=${criId}`,
            { headers: { Authorization: `Bearer ${JSON.parse(token).api_token}` } }
        );
        const data: PaginatedResponse = await res.json();

        return {
            options: data.results.map((item: any) => ({ ...item, value: item.id, label: item.name })),
            hasMore: data.has_more,
            additional: { page: page + 1 },
        };
    };

    const loadOptionsAen = async (search: string, _: any, { page }: any): Promise<any> => {
        if (!seleceteMangerXen?.id) return { options: [], hasMore: false, additional: { page: 1 } };

        const token: any = await localStorage.getItem('kt-auth-react-v');
        const res = await fetch(
            `${getPrefixedUrl('get_department_child')}?search=${search}&page=${page}&id=${seleceteMangerXen.id}&circle_id=${criId}`,
            { headers: { Authorization: `Bearer ${JSON.parse(token).api_token}` } }
        );
        const data: PaginatedResponse = await res.json();

        return {
            options: data.results.map((item: any) => ({ ...item, value: item.id, label: item.name })),
            hasMore: data.has_more,
            additional: { page: page + 1 },
        };
    };

    const loadOptionsJen = async (search: string, _: any, { page }: any): Promise<any> => {
        if (!seleceteMangerAen?.id) return { options: [], hasMore: false, additional: { page: 1 } };

        const token: any = await localStorage.getItem('kt-auth-react-v');
        const res = await fetch(
            `${getPrefixedUrl('get_department_child')}?search=${search}&page=${page}&id=${seleceteMangerAen.id}&circle_id=${criId}`,
            { headers: { Authorization: `Bearer ${JSON.parse(token).api_token}` } }
        );
        const data: PaginatedResponse = await res.json();

        return {
            options: data.results.map((item: any) => ({ ...item, value: item.id, label: item.name })),
            hasMore: data.has_more,
            additional: { page: page + 1 },
        };
    };

    const loadOptionsVendor = async (search: string, _: any, { page }: any): Promise<any> => {
        if (!seleceteMangerJen?.id) return { options: [], hasMore: false, additional: { page: 1 } };

        const token: any = await localStorage.getItem('kt-auth-react-v');
        const res = await fetch(
            `${URL.API_BASE_URL}/api/getAllVendor?circle_id=${criId}&page=${page}&jen_id=${seleceteMangerJen.id}`,
            { headers: { Authorization: `Bearer ${JSON.parse(token).api_token}` } }
        );
        const data: PaginatedResponse = await res.json();

        return {
            options: data.results.map((item: any) => ({ ...item, value: item.id, label: item.user_name || item.name })),
            hasMore: data.has_more,
            additional: { page: page + 1 },
        };
    };

    const generateInvoice = async () => {
        if (!startDate || !endDate || !seleceteMangerVendor?.value) {
            alert('Please select Start Date, End Date, and Vendor');
            return;
        }

        try {
            const token: any = await localStorage.getItem('kt-auth-react-v');
            const response = await axios.get(getPrefixedUrl('invoice'), {
                params: {
                    fromdate: startDate.format('YYYY-MM-DD'),
                    todate: endDate.format('YYYY-MM-DD'),
                    vendor: seleceteMangerVendor.value,
                },
                headers: { Authorization: `Bearer ${JSON.parse(token).api_token}` },
            });

            if (response.data.status) {
                setInvoiceData(response.data.data || []);
                setInvoiceSummary(response.data.invoice_summary || null);
            }
        } catch (error) {
            console.error(error);
            alert('Failed to generate invoice');
        }
    };

    const calculateTpAmount = () => {
        if (!invoiceSummary) return 0;
        return (invoiceSummary.grand_total * tpPercentage) / 100;
    };

    // Visibility helpers
    const isJen = userPrefix === 'jens' || userProfile?.role_id === 7;
    const isAen = userPrefix === 'aens' || userProfile?.role_id === 6;
    const hideCircleAndXen = isJen || isAen;
    const hideAen = isJen;   // Only hide Aen for JEN

    return (
        <div>
            <div className='d-flex flex-column flex-wrap justify-content-center me-3 page-title'>
                <h1 className='d-flex flex-column justify-content-center my-0 fw-bold text-dark page-heading fs-3'>
                    Generate Invoice
                </h1>
                <ul className='my-0 breadcrumb-separatorless pt-1 fw-semibold breadcrumb fs-7'>
                    <li className='breadcrumb-item text-muted'>
                        <Link to={'/'} className='text-hover-primary text-muted'>Home</Link>
                    </li>
                    <li className='breadcrumb-item'>
                        <span className='bg-gray-400 w-5px h-2px bullet'></span>
                    </li>
                    <li className='breadcrumb-item text-muted'>Generate Invoice</li>
                </ul>
            </div>

            <div className='mt-5 p-6 rounded card card-flush'>
                <div className='row'>
                    {/* Circle - Hidden for JEN and AEN */}
                    {!hideCircleAndXen && (
                        <div className='col-3'>
                            <div className='p-5'>
                                <label className='form-label mb-2 fw-semibold fs-6'>
                                    <span className='required'>Circle</span>
                                </label>
                                <select
                                    className='form-control'
                                    value={criId}
                                    onChange={(e) => {
                                        setCriId(e.target.value);
                                        setSeleceteMangerXen(null);
                                        setSeleceteMangerAen(null);
                                        setSeleceteMangerJen(null);
                                        setSeleceteMangerVendor(null);
                                    }}
                                    disabled={!!userProfile?.circle_id}
                                >
                                    <option value=''>Select Circle</option>
                                    {circles.map((c) => (
                                        <option key={c.id} value={c.id}>
                                            {c.name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    )}

                    {/* Xen - Hidden for JEN and AEN */}
                    {!hideCircleAndXen && (
                        <div className='col-3'>
                            <div className='p-5'>
                                <label className='form-label mb-2 fw-semibold fs-6'>
                                    <span className='required'>Select Xen</span>
                                </label>
                                <AsyncPaginate
                                    key={`xen-${criId}`}
                                    value={seleceteMangerXen}
                                    loadOptions={loadOptionsXen}
                                    onChange={(val: Option | null) => {
                                        setSeleceteMangerXen(val);
                                        setSeleceteMangerAen(null);
                                        setSeleceteMangerJen(null);
                                        setSeleceteMangerVendor(null);
                                    }}
                                    additional={{ page: 1 }}
                                    isDisabled={userProfile?.prefix === 'xens' || !criId}
                                    placeholder="Select Xen"
                                />
                            </div>
                        </div>
                    )}

                    {/* Aen - Hidden only for JEN */}
                    {!hideAen && (
                        <div className='col-3'>
                            <div className='p-5'>
                                <label className='form-label mb-2 fw-semibold fs-6'>
                                    <span className='required'>Select Aen</span>
                                </label>
                                <AsyncPaginate
                                    key={`aen-${seleceteMangerXen?.id}`}
                                    value={seleceteMangerAen}
                                    loadOptions={loadOptionsAen}
                                    onChange={(val: Option | null) => {
                                        setSeleceteMangerAen(val);
                                        setSeleceteMangerJen(null);
                                        setSeleceteMangerVendor(null);
                                    }}
                                    additional={{ page: 1 }}
                                    isDisabled={userProfile?.prefix === 'aens' || !seleceteMangerXen?.id}
                                    placeholder="Select Aen"
                                />
                            </div>
                        </div>
                    )}

                    {/* Jen - Always visible */}
                    <div className='col-3'>
                        <div className='p-5'>
                            <label className='form-label mb-2 fw-semibold fs-6'>
                                <span className='required'>Select Jen</span>
                            </label>
                            <AsyncPaginate
                                key={`jen-${seleceteMangerAen?.id}`}
                                value={seleceteMangerJen}
                                loadOptions={loadOptionsJen}
                                onChange={(val: Option | null) => {
                                    setSeleceteMangerJen(val);
                                    setSeleceteMangerVendor(null);
                                }}
                                additional={{ page: 1 }}
                                isDisabled={userProfile?.prefix === 'jens' || !seleceteMangerAen?.id}
                                placeholder="Select Jen"
                            />
                        </div>
                    </div>
                </div>

                <div className='row mt-4'>
                    <div className='col-3'>
                        <label className='form-label mb-2 fw-semibold fs-6'>
                            <span className='required'>Vendor</span>
                        </label>
                        <AsyncPaginate
                            key={`vendor-${seleceteMangerJen?.id}`}
                            value={seleceteMangerVendor}
                            loadOptions={loadOptionsVendor}
                            onChange={(val: Option | null) => setSeleceteMangerVendor(val)}
                            additional={{ page: 1 }}
                            isDisabled={!seleceteMangerJen?.id}
                            placeholder="Select Vendor"
                        />
                    </div>

                    <div className='col-3'>
                        <label className='form-label mb-2 fw-semibold fs-6'>TP (%)</label>
                        <input
                            type="number"
                            className="form-control"
                            onChange={(e) => setTpPercentage(Number(e.target.value) || 0)}
                        />
                    </div>

                    <div className='col-3'>
                        <label className='form-label mb-2 fw-semibold fs-6'>
                            <span className='required'>Start Date</span>
                        </label>
                        <DatePicker onChange={setStartDate} value={startDate} className="form-control" />
                    </div>

                    <div className='col-3'>
                        <label className='form-label mb-2 fw-semibold fs-6'>
                            <span className='required'>End Date</span>
                        </label>
                        <DatePicker onChange={setEndDate} value={endDate} className="form-control" />
                    </div>
                </div>

                <div className='row mt-4'>
                    <div className='col-3'>
                        <label className='form-label mb-2 fw-semibold fs-6'>Bill No</label>
                        <input type="text" className="form-control" value={billNo} onChange={(e) => setBillNo(e.target.value)} />
                    </div>
                    <div className='col-3'>
                        <label className='form-label mb-2 fw-semibold fs-6'>Ref No</label>
                        <input type="text" className="form-control" value={refNo} onChange={(e) => setRefNo(e.target.value)} />
                    </div>
                    <div className='col-3'>
                        <label className='form-label mb-2 fw-semibold fs-6'>GSTIN No</label>
                        <input type="text" className="form-control" value={gstinNo} onChange={(e) => setGstinNo(e.target.value)} />
                    </div>
                    <div className='col-3'>
                        <label className='form-label mb-2 fw-semibold fs-6'>Order No</label>
                        <input type="text" className="form-control" value={orderNo} onChange={(e) => setOrderNo(e.target.value)} />
                    </div>
                </div>

                <div className='text-center mt-8'>
                    <button className="btn btn-success px-10 py-3" onClick={generateInvoice}>
                        Generate Invoice
                    </button>
                </div>
            </div>

            <button className="btn btn-primary mt-4" onClick={() => toPDF()}>
                Download PDF
            </button>

            {/* Invoice Preview */}
            <div className='mt-10 p-6 rounded card card-flush'>
                <div className='body' ref={targetRef}>
                    <div className="header">
                        <div>GSTIN NO: {gstinNo || '_______________________________'}</div>
                        <div className="box">
                            {seleceteMangerVendor?.user_name || seleceteMangerVendor?.name || ""}
                        </div>
                        <div>Ref No. {refNo || '_______________________'}</div>
                        <div>The Executive Engineer : {seleceteMangerXen?.name || "--"}</div>
                        <div className="ak">
                            <div>Dated: {moment().format('DD-MM-YYYY')}</div>
                        </div>
                        <div>BILL NO: {billNo}</div>
                        <div>Dated: {moment().format('DD-MM-YYYY')}</div>
                        <div className="ak">
                            <div>Order No. {orderNo || '____________________________________'}</div>
                            <div>
                                Period: {startDate ? startDate.format('DD-MMM-YYYY') : 'N/A'} To{' '}
                                {endDate ? endDate.format('DD-MMM-YYYY') : 'N/A'}
                            </div>
                        </div>
                        <div style={{ marginTop: '10px' }}>
                            Transportation work of drinking water through tanker under the jurisdiction of RRJ
                        </div>
                    </div>

                    <table>
                        <thead>
                            <tr>
                                <th>S.NO</th>
                                <th>DATE</th>
                                <th>TANKER TRAVEL DISTANCE FROM 0 TO 5 KMS.</th>
                                <th>TANKER TRAVEL DISTANCE FROM 5 TO 10 KMS.</th>
                                <th>TANKER TRAVEL DISTANCE FROM 10 TO 15 KMS.</th>
                                <th>TANKER TRAVEL DISTANCE FROM 15 TO 20 KMS.</th>
                                <th>TANKER TRAVEL DISTANCE FROM ABOVE 20 KMS.</th>
                                <th>TOTAL TRIP</th>
                            </tr>
                        </thead>
                        <tbody>
                            {invoiceData.map((item, index) => (
                                <tr key={item.vehicle_id + item.date}>
                                    <td>{index + 1}</td>
                                    <td>{moment(item.date).format('YYYY-MM-DD')}</td>
                                    <td>{item.distance_0_5_km}</td>
                                    <td>{item.distance_5_10_km}</td>
                                    <td>{item.distance_10_15_km}</td>
                                    <td>{item.distance_15_20_km}</td>
                                    <td>{item.distance_20_plus_km}</td>
                                    <td>{item.total_trips}</td>
                                </tr>
                            ))}
                        </tbody>

                        {invoiceSummary && (
                            <tfoot>
                                <tr className="totals">
                                    <td></td><td></td><td></td>
                                    <td>Total 0-5 Kms Amount</td>
                                    <td>{invoiceSummary.total_0_5_km_trips} × {invoiceSummary.rate_0_5.toFixed(2)} =</td>
                                    <td>{invoiceSummary.amount_0_5.toFixed(2)}</td>
                                </tr>
                                <tr className="totals">
                                    <td></td><td></td><td></td>
                                    <td>Total 5-10 Kms Amount</td>
                                    <td>{invoiceSummary.total_5_10_km_trips} × {invoiceSummary.rate_5_10.toFixed(2)} =</td>
                                    <td>{invoiceSummary.amount_5_10.toFixed(2)}</td>
                                </tr>
                                <tr className="totals">
                                    <td></td><td></td><td></td>
                                    <td>Total 10-15 Kms Amount</td>
                                    <td>{invoiceSummary.total_10_15_km_trips} × {invoiceSummary.rate_10_15?.toFixed(2) || '0.00'} =</td>
                                    <td>{invoiceSummary.amount_10_15?.toFixed(2) || '0.00'}</td>
                                </tr>
                                <tr className="totals">
                                    <td></td><td></td><td></td>
                                    <td>Total 15-20 Kms Amount</td>
                                    <td>{invoiceSummary.total_15_20_km_trips} × {invoiceSummary.rate_15_20?.toFixed(2) || '0.00'} =</td>
                                    <td>{invoiceSummary.amount_15_20?.toFixed(2) || '0.00'}</td>
                                </tr>
                                <tr className="totals">
                                    <td></td><td></td><td></td>
                                    <td>Total 20+ Kms Amount</td>
                                    <td>{invoiceSummary.total_20_plus_km_trips} × {invoiceSummary.rate_20_plus?.toFixed(2) || '0.00'} =</td>
                                    <td>{invoiceSummary.amount_20_plus?.toFixed(2) || '0.00'}</td>
                                </tr>
                                <tr className="totals">
                                    <td></td><td></td><td></td>
                                    <td>Trip Total Amount</td>
                                    <td></td>
                                    <td>{invoiceSummary.grand_total.toFixed(2)}</td>
                                </tr>
                                <tr className="totals">
                                    <td></td><td></td><td></td>
                                    <td>TP {tpPercentage}% Above</td>
                                    <td></td>
                                    <td>{calculateTpAmount().toFixed(2)}</td>
                                </tr>
                                <tr className="totals">
                                    <td></td><td></td><td></td>
                                    <td><b>Grand Total (Payable) Amount</b></td>
                                    <td></td>
                                    <td>{(invoiceSummary.grand_total + calculateTpAmount()).toFixed(2)}</td>
                                </tr>
                            </tfoot>
                        )}
                    </table>

                    <p className='text-center mt-4'>
                        --- This is a system generated invoice and does not require any signature or stamp ---
                    </p>
                </div>
            </div>
        </div>
    );
};

export default Vef_Invoice;




